import React from 'react';
import type * as MonacoEditor from 'monaco-editor/esm/vs/editor/editor.api';
import InputMappingControlList from './InputMappingControlList';
import SensorMappingControlList from './SensorMappingControlList';
import type { SensorActionSide } from '../../../CodeEditor/ConfigurationTabs/sensorMappingConstants';
import type { SensorMappingDraftLike } from './sensorMappingTypes';

export type ActionMappingControlListProps =
  | {
      variant?: 'input';
      device: 'controller' | 'drivebase';
      editor?: MonacoEditor.editor.IStandaloneCodeEditor;
    }
  | {
      variant: 'sensor';
      sensorVarNames: string[];
      draftsBySensorVar: Record<string, SensorMappingDraftLike | undefined>;
      onAddSensorMapping: (sensorVarName: string) => void;
      onEditSensor: (sensorVarName: string, triggerIndex: number, side?: SensorActionSide, actionIndex?: number) => void;
      onDeleteSensorMapping: (sensorVarName: string, triggerIndex: number, side: SensorActionSide, actionIndex: number) => void;
    };

const ActionMappingControlList: React.FC<ActionMappingControlListProps> = (props) => {
  if (props.variant === 'sensor') {
    return <SensorMappingControlList {...props} />;
  }
  return <InputMappingControlList device={props.device} editor={props.editor} />;
};

export default ActionMappingControlList;
